if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(51[29]|036|354|376|874)|3(6(34|70|84)|014|502|778|956)|4(317|737|782|93)|5(478|50|874)|6(24|296|386|460|698|78)|7(014|196|672|918)|8(45[04]|050|198|312|542)|9(11[04]|(03|29|30)6)|1334|1818)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}